import { SearchEconomicUnitsQuery } from '@predium/client-graphql';
import { useEntitySearch } from '@/components/global-search/hooks/useEntitySearch';
import { getEconomicUnitItems } from '@/components/global-search/utils';
import { useSession } from '@/components/session/useSession';
import { SEARCH_ECONOMIC_UNITS } from '@/graphql/StatusQuoAnalysis.queries';

type EconomicUnit = SearchEconomicUnitsQuery['economic_unit'][0];

const economicUnitDataExtractor = (data: SearchEconomicUnitsQuery | undefined): EconomicUnit[] =>
  data?.economic_unit ?? [];

export function useSearchEconomicUnit(searchText: string) {
  const {
    org: { isEconomicUnitsToggled },
  } = useSession();

  const { data, loading, error } = useEntitySearch<SearchEconomicUnitsQuery, EconomicUnit>({
    query: SEARCH_ECONOMIC_UNITS,
    dataExtractor: economicUnitDataExtractor,
    searchText,
    skip: !isEconomicUnitsToggled,
  });

  return {
    economicUnits: getEconomicUnitItems(data),
    loading,
    error,
  };
}
